"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlobContent = exports.LazyNativeContent = void 0;
var promise_1 = require("../../utils/promise");
var utils_1 = require("../utils");
var lazy_1 = require("../../common/lazy");
var encoding_1 = require("../../utils/encoding");
var LazyNativeContent = /** @class */ (function (_super) {
    __extends(LazyNativeContent, _super);
    function LazyNativeContent(getFunc, disposeFunc) {
        return _super.call(this, getFunc, disposeFunc) || this;
    }
    return LazyNativeContent;
}(lazy_1.DisposableLazy));
exports.LazyNativeContent = LazyNativeContent;
var BlobContent = /** @class */ (function () {
    function BlobContent(content) {
        this.content = content;
        if (!content)
            this.content = new Blob([]);
    }
    BlobContent.prototype.blob = function () {
        return this.content;
    };
    BlobContent.prototype.read = function (offset, length) {
        if (!offset)
            offset = 0;
        if (!length)
            length = this.content.size - offset;
        if (offset < 0)
            throw new Error("Invalid offset " + offset);
        if (length < 0 || length === 0)
            throw new Error("Invalid length " + length);
        return this.content.slice(offset, offset + length);
    };
    //Warning! DomString always encodes to UTF-8
    BlobContent.prototype.write = function (blob, offset) {
        if (!offset)
            offset = 0;
        if (offset < 0)
            throw new Error("Invalid offset " + offset);
        if (offset === this.content.size) {
            this.content = new Blob([this.content, blob]);
            return;
        }
        var parts = [];
        if (offset < this.content.size && offset > 0) {
            parts.push(this.content.slice(0, offset));
        }
        else if (offset === this.content.size) {
            parts.push(this.content);
        }
        else if (offset > this.content.size) {
            parts.push(this.content);
            parts.push(new Uint8Array(offset - this.content.size));
        }
        parts.push(blob);
        var blobSize = new Blob([blob]).size;
        if (this.content.size > blobSize + offset) {
            parts.push(this.content.slice(blobSize + offset, this.content.size));
        }
        this.content = new Blob(parts);
    };
    BlobContent.prototype.readBlob = function (offset, length) {
        return (0, promise_1.promiseResolve)(this.read(offset, length));
    };
    BlobContent.prototype.writeBlob = function (blob, offset) {
        return (0, promise_1.promiseResolve)(this.write(blob, offset));
    };
    BlobContent.prototype.readBuffer = function (offset, length) {
        var _this = this;
        return (0, utils_1.readNative)(function (reader) {
            return reader.readAsArrayBuffer(_this.read(offset, length));
        });
    };
    BlobContent.prototype.writeBuffer = function (buffer, offset) {
        return (0, promise_1.promiseResolve)(this.write(buffer, offset));
    };
    BlobContent.prototype.readText = function (codepage, offset, length) {
        var chunk = this.read(offset, length);
        var encoding = (0, encoding_1.getEncodingOrNull)(codepage);
        if (!encoding)
            return (0, encoding_1.readGuessingEncoding)(new BlobContent(chunk));
        return (0, utils_1.readNative)(function (reader) { return reader.readAsText(chunk, encoding); });
    };
    BlobContent.prototype.writeText = function (text, codepage, offset) {
        if (codepage && codepage !== 1251 && codepage !== 65001) {
            throw new Error("Can't write text to blob with " + codepage + " codepage");
        }
        return (0, promise_1.promiseResolve)(this.write(codepage === 1251 ? (0, encoding_1.encodeStringToWindows1251)(text).buffer : text, offset));
    };
    BlobContent.prototype.readBase64 = function (offset, length) {
        var _this = this;
        if (offset < 0)
            throw new Error("Invalid offset " + offset);
        if (length < 0 || length === 0)
            throw new Error("Invalid length " + length);
        return (0, utils_1.readNative)(function (reader) {
            return reader.readAsDataURL(_this.read(offset, length));
        }).then(function (dataUrl) {
            return dataUrl.substr(dataUrl.indexOf(",") + 1);
        });
    };
    BlobContent.prototype.writeBase64 = function (base64, offset) {
        return (0, promise_1.promiseResolve)(this.write((0, utils_1.base64toBlob)(base64), offset));
    };
    BlobContent.prototype.size = function () {
        return (0, promise_1.promiseResolve)(this.content.size);
    };
    BlobContent.prototype.isDisposed = function () {
        return this.disposed;
    };
    BlobContent.prototype.dispose = function () {
        this.disposed = true;
        this.content = null;
    };
    return BlobContent;
}());
exports.BlobContent = BlobContent;
